<ridango-modal [size]="'460'" [visible]="showNavigationModal" (onCloseModal)="cancel()"
               [outsideClickAllowed]="false">
    <div class="shopping-cart-navigation">
        <div class="shopping-cart-navigation-area">
            <p class="title">
                {{ translations.title | translate }}
            </p>

            <div class="shopping-cart-navigation-middle">
                <p>
                    {{ translations.text | translate }}
                </p>

                <p class="bold">
                    {{ translations.textBold | translate }}
                </p>
            </div>


            <div class="shopping-cart-navigation-bottom">
                <div class="shopping-cart-navigation-bottom__btn">
                    <button class="btn btn--primary btn--maximal"
                            (click)="confirm()">
                        {{ translations.allowNavigation | translate }}
                    </button>
                </div>

                <div class="shopping-cart-navigation-bottom__link">
                    <a (click)="cancel()" class="link link--action link--emphasized">
                        {{ translations.cancel | translate }}
                    </a>
                </div>
            </div>

        </div>
    </div>
</ridango-modal>